import { Col, Row } from "react-grid-system";
import styled from "styled-components";

export default function PromoDR(props: any) {
  const pub = {
    url: "https://www.instagram.com/rosesmartphone/",
    logo: "https://i.postimg.cc/c4qWnYtQ/51ddd7d4-6cf7-4d7a-ac25-c58512d0d10b-removebg-preview.png",
  };

  return (
    <Content>
      <div className="content">
        <Row justify="center" align="center">
          <Col xs={12}>
            <h4>
              Crea tu <span>menu digital</span>
            </h4>
          </Col>
          <Col xs={12}>
            <a href="hhttps://www.instagram.com/menudr.app/" target={"_blank"}>
              Escribenos
            </a>
          </Col>
        </Row>
      </div>
    </Content>
  );
}

const Content = styled.div`
  padding: 2em 1em;
  text-align: center;

  background: white;
`;
